import React, { memo } from "react";
import { Badge, Table } from "react-daisyui";
import { CheckIcon,  XMarkIcon, QuestionMarkCircleIcon} from "@heroicons/react/24/outline";
import Participant from "../../../../interfaces/participant";
import HighlightText from "../Hightlight";

interface Props {
  participants: any[];
  navigateToParticipant: (id: number) => void;
  filter: string;
  selectedRow: Set<number>;
  toggleSelection: (id: number, token: string) => void;
  selectAllRow: () => void;
  isAllRowSelected: boolean;
  openModifyResponsesModal: () => void;
  getParticipantId: ([]: any) => void;
  openViewReportModal: () => void;
  sending_report: string;
}

const ParticipantTable: React.FC<Props> = ({
  participants,
  navigateToParticipant,
  filter,
  selectedRow,
  toggleSelection,
  selectAllRow,
  isAllRowSelected,
  openModifyResponsesModal,
  getParticipantId,
  openViewReportModal,
  sending_report
}) => (
  <Table className="w-full mb-2">
    <Table.Head>
      <span>
        <label>
          <input
            id="ParticipantTableSelectAllInput"
            type="checkbox"
            checked={isAllRowSelected}
            onChange={(e) => {
              e.stopPropagation();
              selectAllRow();
            }}
            className="w-5 h-5 cursor-pointer"
          />
        </label>
      </span>
      <span>ID</span>
      <span>Status</span>
      <span>Emailed Study</span>
      <span>Response Status</span>
      <span>Actions</span>
      {/* <span>First Name</span>
      <span>Last Name</span>
      <span>Email</span>
      <span>Survey Token</span> */}
    </Table.Head>

    <Table.Body>
      {participants.map((participant: Participant) => (
        <Table.Row
          key={participant.id}
          hover
          className=""
          // onClick={(e) => {
          //   // Check if the target of the click is a checkbox or the first cell of the table row
          //   if (
          //     e.target instanceof HTMLInputElement ||
          //     (e.target as HTMLElement).parentElement?.firstChild === e.target
          //   ) {
          //     // It's a checkbox or the first cell of the row, do nothing
          //     return;
          //   }
          //   navigateToParticipant(participant.id);
          // }}
        >
          <input
            type="checkbox"
            id={`ParticipantTableRowInput${participant.id}`}
            checked={selectedRow?.has(participant.id)}
            onChange={(e) => {
              e.stopPropagation();
              toggleSelection(participant.id, participant.limesurvey_token);
            }}
            className="w-5 h-5 cursor-pointer"
          />
          <span>{participant.id}</span>
          <span>
            {participant.activated && <Badge color="success" size="lg"><CheckIcon className="h-4 w-4"></CheckIcon> active</Badge> }
            {!participant.activated && <Badge size="lg"><XMarkIcon className="h-4 w-4"></XMarkIcon>inactive</Badge> }
          </span>
          <span>
            {participant.emailed_token && <Badge color="success" size="lg"><CheckIcon className="h-4 w-4"></CheckIcon> sent</Badge> }
            {!participant.emailed_token && <Badge size="lg"><XMarkIcon className="h-4 w-4"></XMarkIcon>not sent</Badge> }
          </span>
          <span>
            {(participant.calculated) && <Badge color="success" size="lg"><CheckIcon className="h-4 w-4"></CheckIcon> calculated</Badge> }
            {(participant.responded && !participant.calculated) && <Badge color="warning" size="lg"><QuestionMarkCircleIcon className="h-4 w-4"></QuestionMarkCircleIcon> responded</Badge> }
            {(!participant.responded && !participant.calculated) && <Badge size="lg"><XMarkIcon className="h-4 w-4"></XMarkIcon> not received</Badge> }
          </span>
          {/* <span>
            {sending_report === 'SUCCESS' && participant.emailed_report && <Badge color="success" size="lg"><CheckIcon className="h-4 w-4"></CheckIcon> sent</Badge> }
            {sending_report === 'PENDING'|| sending_report === 'STARTED' && <div className="flex items-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              in progress ...
            </div>}
           
            {sending_report !== 'STARTED' &&  !participant.emailed_report && <Badge size="lg"><XMarkIcon className="h-4 w-4"></XMarkIcon>not sent</Badge> }
          </span> */}
          <span>
            {" "}
            <a
              id={`ParticipantTableRowViewReportButton${participant.id}`}
              onClick={(e) => {
                e.stopPropagation();
                getParticipantId(participant.id);
                openViewReportModal()
              }}
              className="text-blue-500 link link-hover"
            >
              view pdf
            </a>{" "}
            |{" "}
            <a
              id={`ParticipantTableRowDeleteResponseButton${participant.id}`}
              href="#"
              onClick={(e) => {
                e.stopPropagation();
                getParticipantId(participant.id);
                openModifyResponsesModal();
              }}
              className="text-blue-500 link link-hover"
            >
              delete response
            </a>
          </span>

          {/* <HighlightText text={participant.CFirname} highlight={filter} />
          <span>{participant.CSurname}</span>
          <span>{participant.CEmail}</span>
          <span>{participant.limesurvey_token}</span> */}
          {/* <span>
            {participant.active ? <CheckIcon className="h-4 w-4"></CheckIcon> : null}
          </span> */}
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

export default ParticipantTable;
